import * as React from 'react'

const SvgComponent = props => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={9} stroke="#666" strokeWidth={4} />
  </svg>
)

export default SvgComponent
